import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { columnDefs } from './definitions-config';
import { Icon } from 'semantic-ui-react';
import {
  updateRoundStatus,
  completeAction,
} from '../../../../services/apiService';
import './index.css';

function InterviewsTable({ rowData, onReload, setSortType }) {
  const ButtonRenderer = (params) => {
    return (
      <div className='relative flex items-center '>
        <Icon name='ellipsis horizontal' />
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ButtonRenderer,
    statusRenderer: StatusGetter,
  };

  function StatusGetter(params) {
    // const [status, setStatus] = useState(params?.data?.status);
    const statusOptions = [
      {
        key: 'unscheduled',
        text: 'Unscheduled',
        value: 'unscheduled',
        disabled: true,
      },
      {
        key: 'scheduled',
        text: 'Scheduled',
        value: 'scheduled',
        disabled: true,
      },
      {
        key: 'cleared',
        text: 'Cleared',
        value: 'cleared',
      },
      {
        key: 'not cleared',
        text: 'Not Cleared',
        value: 'not cleared',
      },
      {
        key: 'decision awaiting',
        text: 'Decision awaiting',
        value: 'decision awaiting',
      },
      {
        key: 'paused',
        text: 'Paused',
        value: 'paused',
      },
    ];

    const status = params?.data?.status;

    // call update status with status and roundId
    const handleStatusChange = async (status) => {
      try {
        await updateRoundStatus({
          status,
          roundId: params?.data?.roundId,
        });
        await completeAction({
          actionType: 'update_round_decision',
          roundId: params?.data?.roundId,
        });
        params?.onChangeHandler();
      } catch (error) {
        console.log('error in updating status::', error);
      }
    };

    const renderJobApplicationStatus = (status) => {
      const JA_STATUS = {
        IN_PROGRESS: 'in progress',
        COMPLETED: 'completed',
        OFFER_MADE: 'offer made',
        REJECTED: 'rejected',
      };

      switch (status) {
        case JA_STATUS.IN_PROGRESS:
          return <p className='text-base font-extrabold '>In progress</p>;
        case JA_STATUS.COMPLETED:
          return <p className='text-base font-extrabold '>Completed</p>;
        case JA_STATUS.OFFER_MADE:
          return <p className='text-base font-extrabold '>Offer made</p>;
        case JA_STATUS.REJECTED:
          return <p className='text-base font-extrabold '>Rejected</p>;
        default:
          return <p className='text-base font-extrabold '>In progress</p>;
      }
    };

    return (
      <div className='relative flex items-center justify-center top-2'>
        <div style={{ position: 'relative' }}>
          {!params.data &&
            renderJobApplicationStatus(
              params?.node.allLeafChildren[0]?.data?.jobApplicationDetails
                ?.currentStatus
            )}
          {params?.data?.roundNumber && (
            <select
              value={status}
              onChange={(e) => {
                handleStatusChange(e.target.value);
              }}
            >
              {statusOptions.map((item) => (
                <option
                  key={item.key}
                  value={item.value}
                  disabled={item.disabled ?? false}
                >
                  {' '}
                  {item.text}{' '}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
    );
  }
  const rowStyle = { background: 'white' };

  const getRowStyle = (params) => {
    return {
      background: 'white',
      borderBottom: '1px solid #e6e6e6',
      fontSize: '16px',
      color: '#5E6E88',
    };
  };

  return (
    <div className='ag-theme-balham' style={{ height: '75vh', width: '100%' }}>
      <AgGridReact
        columnDefs={[
          ...columnDefs,
          {
            field: 'status',
            headerName: 'Status',
            cellRenderer: 'statusRenderer',
            cellRendererParams: {
              onChangeHandler: onReload,
            },
          },
        ]}
        // defaultColDef={defaultColDef}
        rowStyle={rowStyle}
        getRowStyle={getRowStyle}
        rowHeight={50}
        rowData={rowData || []}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        suppressPaginationPanel
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        frameworkComponents={frameworkComponents}
        onSortChanged={(params) => {
          const column = params?.columnApi
            ?.getColumnState()
            ?.filter((item) => item.sort)?.[0];
          if (column.colId === 'startTime') {
            setSortType(column.sort.toUpperCase());
          }
        }}
      />
    </div>
  );
}

export default InterviewsTable;
